<div class="px-4 py-8 md:py-16 md:px-6 lg:px-8 max-w-4xl mx-auto">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
    <div>
      <div class="text-2xl font-bold text-gray-900 mb-4">GET IN TOUCH</div>
      <p class="text-gray-700 leading-7 pr-0 lg:pr-5 mb-4">
        If you have any queries please use the details below, or fill out the form to send us an email.
      </p>
      <div class="flex items-center mb-4">
        <div>
          <span class="flex items-center justify-center bg-gray-100 rounded-full mr-3 h-12 w-12">
            <i class="pi pi-inbox text-gray-900 !text-xl"></i>
          </span>
        </div>
        @if (contactInformation.email) {
          <div>
            <span class="text-xl font-semibold text-gray-900 mb-2 block">Email</span>
            <p class="text-gray-700 my-1">
              <a class="text-green-700 hover:underline" href="mailto:{{ contactInformation.email }}">{{ contactInformation.email }}</a>
            </p>
          </div>
        }
      </div>
      <div class="flex items-center">
        <div>
          <span class="flex items-center justify-center bg-gray-100 rounded-full mr-3 h-12 w-12">
            <i class="pi pi-phone text-gray-900 !text-xl"></i>
          </span>
        </div>
        @if (contactInformation.phone) {
          <div>
            <span class="text-xl font-semibold text-gray-900 mb-2 block">Phone</span>
            <p class="text-gray-700 my-1">
              <a class="text-green-700 hover:underline" href="tel:{{ contactInformation.phone.number }}">{{
                contactInformation.phone.displayedNumber
              }}</a>
            </p>
          </div>
        }
      </div>
    </div>
    <div>
      <div class="flex flex-col gap-4">
        <div>
          <label class="font-semibold" for="name">Name</label>
          <input class="w-full" id="name" pInputText type="text" />
        </div>
        <div>
          <label class="font-semibold" for="email">Email</label>
          <input class="w-full" id="email" pInputText type="text" />
        </div>
        <div>
          <label class="font-semibold" for="message">Message</label>
          <textarea class="w-full" id="message" pTextarea rows="4"></textarea>
        </div>
        <button aria-label="Send Message" class="self-end" icon="pi pi-send" label="Send Message" pButton pRipple type="button"></button>
      </div>
    </div>
  </div>
</div>
